module.exports = __webpack_public_path__ + "static/media/product.ddc86f76.svg";